import { useSettingsStore } from "./settingsStore";

export const DEMO_MODE_KEY = "kaynin_demo_mode_enabled";

export const isGlobalDemoModeEnabled = (): boolean => {
  return useSettingsStore.getState().getSetting(DEMO_MODE_KEY, true) as boolean;
};

export const setGlobalDemoModeEnabled = (enabled: boolean): void => {
  useSettingsStore.getState().updateSetting(DEMO_MODE_KEY, enabled);
};
